import { render, staticRenderFns } from "./partnerIntroduce.vue?vue&type=template&id=35b187e5&scoped=true&"
import script from "./partnerIntroduce.vue?vue&type=script&lang=js&"
export * from "./partnerIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./partnerIntroduce.vue?vue&type=style&index=0&id=35b187e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b187e5",
  null
  
)

export default component.exports